import { Badge } from '@signozhq/ui/badge';

export default function BetaTag(): JSX.Element {
	return (
		<Badge variant="solid" color="primary">
			Beta
		</Badge>
	);
}
